module.exports = "/_next/static/images/Collection@2x-0d7d8cc027b16ffc5aea986775a6c75a.webp";